import * as React from 'react';
import styled from 'styled-components';

import { media, themeGet, colors, BotTrap, ContentContainer, Flex, Box } from '@packages/ui';

import {
  NavigationListLi,
  NavigationListUl,
  NavigationListHeadline,
  NavigationListForFooter,
} from './NavigationListForFooter';
import { LinkItemForFooterProps } from './LinkItemForFooter';

const Container = styled.div.attrs({ 'data-testid': 'footer-links-container' })`
  background: ${themeGet.colors('desertStorm')};
  padding: ${themeGet.space(3)} ${themeGet.space(2)};
  font-size: ${themeGet.fontSize(7)};
  width: 100%;

  ${NavigationListHeadline} {
    font-weight: 500;
    text-align: left;
    margin: 0;
    line-height: 4rem;
    font-size: ${themeGet.fontSize(6)};
    margin-bottom: ${themeGet.space(2)};
    ${media.to.md`
      font-size: ${themeGet.fontSize(6)};
    `}
  }

  ${NavigationListLi} {
    padding: 3px 0px;
  }

  ${media.from.md`
    font-size: ${themeGet.fontSize(8)};
    padding: ${themeGet.space(4)};
  `};
`;

// TODO: fix color
const Main = styled(Box)`
  ${media.from.md`
    border-right: 1px #c7c7c7 solid;
  `};
`;

const Follow = styled(Box)`
  ${NavigationListUl} {
    flex-wrap: wrap;
  }

  ${NavigationListLi} {
    width: 50%;

    &:nth-child(even) {
      padding-left: ${themeGet.space(4)};
    }
  }

  ${media.from.md`
    flex-wrap: nowrap;

    ${NavigationListLi} {
      width: auto;

      &:nth-child(even) {
         padding-left: 0;
      }
    }
  `};
`;

const colWidth = [6 / 12, 6 / 12, 3 / 12];

export interface EachFooterSectionProps {
  headline?: string;
  id: string;
  items?: LinkItemForFooterProps[];
}

export interface FooterLinksProps {
  main: EachFooterSectionProps[][];
  follow: EachFooterSectionProps[];
}

export const FooterLinks: React.FC<FooterLinksProps> = ({ main = [], follow = [] }) => (
  <Container>
    <ContentContainer>
      <Flex flexWrap="wrap">
        <Main width={[1, 1, 9 / 12]}>
          <Flex flexWrap="wrap">
            {main.map((listArray, index) => (
              <Box width={colWidth} px={2} key={`footer-link-box-${index}`}>
                {listArray.map((item, idx) => (
                  <NavigationListForFooter
                    {...item}
                    key={`navigation-list-for-footer-${idx}-${item.id}`}
                    flexDirection="column"
                  />
                ))}
              </Box>
            ))}
          </Flex>
        </Main>
        <Box width={[1, 1, 1 / 12]} />
        <Follow width={[1, 1, 2 / 12]} px={2}>
          {follow.map((item, idx) => (
            <NavigationListForFooter
              {...item}
              key={`follow-navigation-list-for-footer-${idx}-${item.id}`}
              flexDirection={['row', 'row', 'column']}
            />
          ))}
          <BotTrap backgroundColor={colors.desertStorm} />
        </Follow>
      </Flex>
    </ContentContainer>
  </Container>
);
